module.exports = __webpack_public_path__ + "img/NO.93a89ef2.svg";